import { Pipe, PipeTransform } from '@angular/core';
const KM_PER_MILE: number = 1.609344;

@Pipe({ name: 'speed' })
export class SpeedValuePipe implements PipeTransform {
  public transform(speed: number, userMetricUnits: boolean, currentDataUnits: string, decimalPlaces: number = 0): number {
    if (speed === null || speed === undefined || isNaN(speed)) {
      return;
    }
    if ((userMetricUnits && currentDataUnits === 'kph') ||
      (!userMetricUnits && currentDataUnits !== 'kph')) {
      return parseFloat(speed.toFixed(decimalPlaces));
    } else if (userMetricUnits && currentDataUnits !== 'kph') {
      return parseFloat((speed * KM_PER_MILE).toFixed(decimalPlaces));
    } else if (!userMetricUnits && currentDataUnits === 'kph') {
      return parseFloat((speed / KM_PER_MILE).toFixed(decimalPlaces));
    }
  }
}
